import { render, staticRenderFns } from "./payout.vue?vue&type=template&id=256f5566&scoped=true"
import script from "./payout.vue?vue&type=script&lang=js"
export * from "./payout.vue?vue&type=script&lang=js"
import style0 from "./payout.vue?vue&type=style&index=0&id=256f5566&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256f5566",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('256f5566')) {
      api.createRecord('256f5566', component.options)
    } else {
      api.reload('256f5566', component.options)
    }
    module.hot.accept("./payout.vue?vue&type=template&id=256f5566&scoped=true", function () {
      api.rerender('256f5566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/data-agent/payout.vue"
export default component.exports